export default __webpack_public_path__ + "static/media/share-icon.b87f189f.svg";